var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerOff(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.25 13.5H12.75C13.1719 13.5 13.5 13.1719 13.5 12.75V0.75C13.5 0.328125 13.1719 0 12.75 0H11.25C10.8281 0 10.5 0.328125 10.5 0.75V12.75C10.5 13.1719 10.8281 13.5 11.25 13.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8439 3.04648C18.0939 2.53086 17.0627 2.76523 16.6408 3.56211L16.2658 4.21836C15.8908 4.87461 16.0783 5.67148 16.6408 6.09336C18.422 7.54648 19.5002 9.70273 19.5002 11.9996C19.5002 16.7809 15.0002 20.5309 9.98453 19.2184C7.73453 18.6559 5.85953 16.9684 5.01578 14.8121C3.75015 11.5309 4.87515 8.10898 7.35953 6.14023C7.92203 5.67148 8.10953 4.87461 7.73453 4.21836L7.35953 3.56211C6.93765 2.76523 5.9064 2.53086 5.1564 3.04648C1.7814 5.67148 0.047026 10.0777 1.0314 14.484C2.10953 19.2652 6.32828 22.8746 11.2033 23.2027C17.7658 23.6715 23.2502 18.4684 23.2502 11.9996C23.2502 8.48398 21.6095 5.15586 18.8439 3.04648Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerOff);
export default __webpack_public_path__ + "static/media/power-off.14135378.svg";
export { ForwardRef as ReactComponent };